<header class="app-header navbar">
  <a href="#" class="navbar-brand" routerLink="/">Apsis One - Back Office</a>

  <ul class="nav navbar-nav ml-auto">
    <li id="qsLoginBtn" class="nav-item" *ngIf="!isAuthenticated">
      <a href="#" (click)="onLogin()">Log In</a>
    </li>

    <li *ngIf="isAuthenticated" class="nav-item recents">
      <app-recent-routes [inHeader]="true"></app-recent-routes>
    </li>

    <li
      *ngIf="isAuthenticated && profile"
      class="nav-item dropdown"
      ngbDropdown
      placement="bottom-right"
    >
      <div class="name">
        {{ profile.name }}
      </div>
      <button class="nav-link" id="header-dropdown" ngbDropdownToggle>
        <img src="{{ profile.picture }}" alt="User avatar" class="img-avatar" />
      </button>

      <div
        ngbDropdownMenu
        aria-labelledby="header-dropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <button
          class="dropdown-item"
          routerLink="/au/users/{{ profile.userId }}"
        >
          <i class="fas fa-user"></i> My User
        </button>
        <button class="dropdown-item" (click)="onLogout()">
          <i class="fas fa-sign-out-alt"></i> Log Out
        </button>
      </div>
    </li>
  </ul>
</header>
